import {
  CmpTypographyField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import { Box } from "@mui/material";

export default function WmsContent({
  sEnterKeyObj,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,

  xBufferObj,
  sUnit,

  fUnit,
  fQty,
  fQty_Enter,
  fItemName,

  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
}) {
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <form
        className="Wms-inbound-grn-content mt-1"
        id="WmsStockAdjustmentContent"
      >
        <Grid
          container
          spacing={{ xs: 0.9, sm: 1, md: 1 }}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        >
          {/* <Grid item xs={4} sm={1} md={1.5} className="lastkeyDetect">
          <CmpTypographyField xcomponent={"div"} xText={"S.No"} />
          <CmpInputField
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
            // xOnKeyUp={xKey}
          />
        </Grid> */}

          <Grid item xs={12} sm={1.7} md={3} className="lastkeyDetect">
            {/* <CmpTypographyField xcomponent={"div"} xText={"Item Code"} /> */}
            <CmpTextFieldV1
              xLabelText="Item Code"
              xValue={xBufferObj.B_Itmcd}
              xType={"text"} // text/number/password
              xName={"B_Itmcd"}
              xReadOnly={true}
              xOnChange={""}
              xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Itmcd}
              // xOnKeyUp={xKey}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={5.5}
            md={xToggle ? 8 : 9}
            // sm={"auto"}
            // md={"auto"}
            // lg={"auto"}
            className="lastkeyDetect"
          >
            <GCToggleSearchV1
              xLabelText="Item Name"
              xtabIndex={"102"}
              xName={"B_ItmName"}
              xType={"text"}
              xValue={xBufferObj?.B_ItmName}
              xReadOnly={false}
              xOnChange={fItemName}
              xOnKeyUp={xonClickbtn}
              xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_ItmName}
              xMediaQuery={xMediaQuery}
              xonClickbtn={xonClickbtn}
              xrows={xrows}
              xcolumns={xcolumns} //head
              xRowCellClick={xRowCellClick}
              xRowClick={xRowClick}
              xToggle={xToggle}
              xData={xData}
              xOnChangeDropdownInput={xOnChangeDropdownInput}
              xDropdownObj={xDropdownObj}
              xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
            />
          </Grid>

          <Grid item xs={4} sm={1.5} md={4} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="Qty"
              xtabIndex={"103"}
              xValue={xBufferObj.B_Qty}
              xType={"number"} // text/number/password
              xName={"B_Qty"}
              xReadOnly={false}
              xOnChange={fQty}
              xError={xErrorMsgDetail.B_Qty === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Qty}
              xOnKeyUp={fQty_Enter}
              xonFocus={(e) => {
                xContent_Focus(e);
              }}
              xonBlur={xContent_Blur}
            />
          </Grid>
          <Grid item xs={4} sm={1.5} md={4} className="lastkeyDetect">
            <CmpSelectFieldV1
              xtabIndex={"104"}
              xLabelText="Unit"
              xValue={xBufferObj.B_Unit}
              xOnChange={fUnit}
              xName={"B_Unit"}
              xData={sUnit}
              xValueMember={""}
              xDispalyMember={""}
              xError={xErrorMsgDetail.B_Unit === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Unit}
              xDisable={false}
            />
          </Grid>
          <Grid item xs={4} sm={1.8} md={4} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="Packing"
              xtabIndex={"105"}
              xValue={xBufferObj.B_Packing}
              xType={"text"} // text/number/password
              xName={"B_Packing"}
              xReadOnly={true}
              xOnChange={""}
              xError={xErrorMsgDetail.B_Packing === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Packing}
              // xOnKeyUp={xKey}
            />
          </Grid>
          {/* <Grid item xs={4} sm={2} md={8} className="lastkeyDetect">
          <CmpTypographyField xcomponent={"div"} xText={"Base Qty "} />
          <CmpInputField
            xtabIndex={"106"}
            xValue={xBufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BaseQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BaseQty}
            // xOnKeyUp={xKey}
          />
        </Grid> */}
        </Grid>
      </form>
    </Box>
  );
}
